import React from 'react';
import styles from './ProductImage.module.scss';

const ProductImage = ({
  src,
  alt,
  width = 260,
  height = 260,
  loading = 'lazy',
  fetchPriority,
  className,
  onError,
  onLoad,
}) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    loading={loading}
    fetchPriority={fetchPriority}
    decoding="async"
    data-product-image=""
    className={[styles.root, className].filter(Boolean).join(' ')}
    onError={onError}
    onLoad={onLoad}
  />
);

export default ProductImage;
